<div class="mb-myaccount-tile-wrapper">
  <div class="mb-myaccount-tile"
       (click)="linkUrl !== '' ? openLink() : false"
       [class.mb-myaccount-tile-link]="linkUrl !== ''"
       [class.hover]="hover"
       [class.mb-myaccount-welcome-tile]="welcomeTile"
       [style.background-image]="'url(' + backgroundImageLocation + ')'">
    <div class="mb-myaccount-tile-text"
         [class.mb-myaccount-tile-text-large]="textLarge"
         [ngClass]="textAlignment">
      <div *ngIf="linkUrl !== ''">
        <span>{{linkText}}</span>
      </div>
      <div class="mb-myaccount-tile-text-lg" *ngIf="linkUrl === ''">
        <span>{{text}}</span>
      </div>
      <div class="mb-myaccount-tile-text-xs" *ngIf="linkUrl === ''">
        <span>{{mobileText}}</span>
      </div>
    </div>
  </div>
</div>
